/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum CourseSort {
  'title,asc' = 'title,asc',
  'title,desc' = 'title,desc',
  'description,asc' = 'description,asc',
  'description,desc' = 'description,desc',
  'enrolled_at,asc' = 'enrolled_at,asc',
  'enrolled_at,desc' = 'enrolled_at,desc',
  'access,asc' = 'access,asc',
  'access,desc' = 'access,desc',
  random = 'random'
}
